import { Button } from '@efexteam/components';
import { Actions, Can, Subjects } from '@efexteam/permission-manager';
import useUserValidations from '@main-hooks/useUserValidations';
import { Box, Card, CardContent, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MembersTable from './components/membersTable/MembersTable';
import SearchBar from './components/searchBar/SearchBar';
import TeamRolesDescription from './components/TeamRolesDescription/TeamRolesDescription';
import useTeamMember from './hooks/useTeamMember';

const MyTeam = () => {
  const { t } = useTranslation();
  const { isUserValid } = useUserValidations();

  const { search, data, loading, setSearch, navigateToAddMember } =
    useTeamMember();

  return (
    <Grid container spacing={2} className="!my-4">
      <Grid item xs={12} md={8}>
        <Card>
          <CardContent>
            <Box className="flex flex-col sm:flex-row items-center sm:justify-between gap-2">
              <SearchBar setSearch={setSearch} search={search} />
              <Can action={Actions.CREATE} subject={Subjects.TEAM_MEMBERS}>
                <Button
                  appearance="secondary"
                  size="large"
                  sx={{
                    '&.MuiButton-root': {
                      padding: '0 12px',
                      fontSize: '0.8rem',
                    },
                  }}
                  onClick={() => navigateToAddMember()}
                  disabled={!isUserValid}
                >
                  {t('addMember')}
                </Button>
              </Can>
            </Box>
            <MembersTable members={data || []} loading={loading} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <TeamRolesDescription />
      </Grid>
    </Grid>
  );
};

export default MyTeam;
